<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>设置</el-breadcrumb-item>
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="boxLayout">
      <h3 class="title-t mg-b-30">基础信息</h3>
      <el-form
        ref="form"
        :model="basicInfoForm"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item label="旧密码" prop="old_password">
          <el-input
            v-model="basicInfoForm.old_password"
            :type="oldType"
            placeholder="请输入"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-view"
              @click="toggleShow('old')"
            ></i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input
            v-model="basicInfoForm.new_password"
            :type="newType"
            placeholder="至少8位，需含字母、数字、特殊字符"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-view"
              @click="toggleShow('new')"
            ></i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码确认" prop="again_new_password">
          <el-input
            v-model="basicInfoForm.again_new_password"
            :type="againType"
            placeholder="请输入"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-view"
              @click="toggleShow('again_new')"
            ></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="submitting"
            @click="resetPassword('form')"
            >确认修改</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "changePassword",
  data() {
    return {
      oldType: "password",
      newType: "password",
      againType: "password",
      submitting: false,
      basicInfoForm: {
        new_password: "",
        old_password: "",
        again_new_password: "",
      },
      rules: {
        old_password: {
          required: true,
          message: "请输入旧密码",
          trigger: "blur",
        },
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: this.validateStrength, trigger: "blur" },
        ],
        again_new_password: {
          required: true,
          message: "请再次输入新密码",
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    // 密码强度校验：必须同时包含 字母 + 数字 + 特殊字符
    // 与后端 PasswordHelper::checkStrength 保持一致；后端才是最终防线，这里只为即时反馈
    validateStrength(rule, value, callback) {
      if (!value) return callback();
      if (value.length < 8) return callback(new Error("密码长度不能少于8位"));
      if (value.length > 50) return callback(new Error("密码长度不能超过50位"));
      if (/\s/.test(value)) return callback(new Error("密码不能包含空格"));
      if (!/[A-Za-z]/.test(value)) return callback(new Error("密码必须包含字母"));
      if (!/[0-9]/.test(value)) return callback(new Error("密码必须包含数字"));
      if (!/[^A-Za-z0-9]/.test(value))
        return callback(new Error("密码必须包含特殊字符（如 ! @ # $ % ^ & * - _ . 等）"));
      return callback();
    },
    // 修改密码
    resetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.basicInfoForm.new_password !==
            this.basicInfoForm.again_new_password
          ) {
            this.$message.error("输入的新密码不一致");
            return false;
          }
          if (
            this.basicInfoForm.new_password ===
            this.basicInfoForm.old_password
          ) {
            this.$message.error("新密码不能与旧密码相同");
            return false;
          }
          // 只提交后端需要的两个字段，避免把确认密码一起发出去
          const payload = {
            old_password: this.basicInfoForm.old_password,
            new_password: this.basicInfoForm.new_password,
          };
          // uuid 必须取当前登录用户，早前写死为 1 会去改别人的密码
          const uuid = this.storage.get("__uuid");
          if (!uuid) {
            this.$message.error("登录信息已失效，请重新登录");
            this.$router.replace({ name: "login" });
            return false;
          }
          this.submitting = true;
          this.axios({
            method: "put", //请求方法
            headers: {
              // 必须是 application/json：写成 text/html 时后端解析不到参数，
              // 会一律报“旧密码不正确”
              "Content-Type": "application/json",
              "X-Access-Token": this.storage.get("__token"),
              Authorization: `Bearer ${this.storage.get("__token")}`,
            },
            data: payload,
            url: `${process.env.VUE_APP_API_BASE_URL}/v1/cms/AdminUserResetPassword/${uuid}`,
          })
            .then(() => {
              this.submitting = false;
              this.$message.success("密码修改成功，请使用新密码重新登录");
              // 密码已变更，旧 token 不应继续使用
              setTimeout(() => {
                this.storage.clearAll();
                this.$router.replace({ name: "login" });
              }, 1200);
            })
            .catch((err) => {
              this.submitting = false;
              // 兼容拦截器 reject 出的字符串与原始 axios 错误对象两种形态
              const msg =
                (err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) ||
                (typeof err === "string" ? err : "") ||
                "修改密码失败，请稍后重试";
              this.$message.error(msg);
            });
        } else {
          return false;
        }
      });
    },
    toggleShow(type) {
      if (type == "old") {
        if (this.oldType == "password") {
          this.oldType = "text";
        } else {
          this.oldType = "password";
        }
      } else if (type == "new") {
        if (this.newType == "password") {
          this.newType = "text";
        } else {
          this.newType = "password";
        }
      } else {
        if (this.againType == "password") {
          this.againType = "text";
        } else {
          this.againType = "password";
        }
      }
    },
  },
};
</script>
<style scoped>
.el-form {
  width: 400px;
}
</style>
